import React, { useState } from 'react';
import Modal from '../UI/Modal';
import RazorpayCheckout from '../Payment/RazorpayCheckout';

const PACKAGES = [
	{ type: 'small', credits: 20, price: 10, popular: false },
	{ type: 'medium', credits: 50, price: 25, popular: true },
	{ type: 'large', credits: 120, price: 50, popular: false }
];

export default function CreditsPurchaseModal({ isOpen, onClose, onPurchased }) {
	const [selectedPackage, setSelectedPackage] = useState(null);

	function handleSuccess() {
		onPurchased?.();
		setSelectedPackage(null);
	}

	function handleBack() {
		setSelectedPackage(null);
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title={selectedPackage ? 'Checkout' : 'Purchase Credits'} size="lg">
			{!selectedPackage ? (
				<div className="p-2 grid grid-cols-1 md:grid-cols-3 gap-4">
					{PACKAGES.map((pkg) => (
						<div
							key={pkg.type}
							className={`border-2 rounded-lg p-6 cursor-pointer hover:border-blue-500 transition-all ${
								pkg.popular ? 'border-blue-500 relative' : 'border-gray-200'
							}`}
							onClick={() => setSelectedPackage(pkg)}
						>
							{pkg.popular && (
								<span className="absolute top-0 right-0 bg-blue-500 text-white text-xs px-3 py-1 rounded-bl-lg rounded-tr-lg">
									Most Popular
								</span>
							)}
							<div className="text-center">
								<h3 className="text-xl font-bold capitalize mb-2">{pkg.type}</h3>
								<p className="text-3xl font-bold text-blue-600 mb-2">₹{pkg.price}</p>
								<p className="text-lg font-semibold mb-4">{pkg.credits} Credits</p>
								<p className="text-sm text-gray-600">₹{(pkg.price / pkg.credits).toFixed(2)} per credit</p>
							</div>
						</div>
					))}
				</div>
			) : (
				<RazorpayCheckout packageDetails={selectedPackage} onSuccess={handleSuccess} onClose={handleBack} />
			)}
		</Modal>
	);
}

